import { useCallback } from "react";
import { LayoutGrid, Upload } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { EDITOR_KEYS } from "@/other/constants/EditorKeys";
import { IMPORT_TYPES, IMPORT_HEADERS } from "@/other/constants/OtherKeys";
import { GRANTS } from "@/other/constants/PrivilegeTypes";
import { useCoverage } from "../context/CoverageContext";
import { HubRow } from "./HubRow";

export const HubLandscapeGrid = () => {
  const { filteredHubs, problemHubs, setActiveFilter, setSearchQuery } = useCoverage();
  const { editorHandler, user } = useSwivuBryntumContext();

  const openImportEditor = useCallback(() => {
    if (!editorHandler) return;
    editorHandler.openEditor(
      EDITOR_KEYS.importEditor,
      // @ts-expect-error - editorHandler.openEditor second parameter accepts null
      null,
      {
        importType: IMPORT_TYPES.marketingTags,
        canEdit: user && user.can(GRANTS.grant_one),
        importHeader: IMPORT_HEADERS.marketingTags,
        labelIndex: 1,
      },
      { useExisting: true, by: "recordType" },
    );
  }, [editorHandler, user]);

  if (problemHubs.length === 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 px-8 text-center">
        <LayoutGrid className="size-6 text-muted-foreground/50" />
        <div className="space-y-1.5">
          <h3 className="text-sm font-semibold text-foreground">No problem hubs yet</h3>
          <p className="text-xs text-muted-foreground">
            Import problem tags to start tracking coverage across your content landscape.
          </p>
        </div>
        <Button size="sm" className="inline-flex items-center gap-2" onClick={openImportEditor}>
          <Upload className="size-4" />
          Import Tags
        </Button>
      </div>
    );
  }

  if (filteredHubs.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <p className="text-sm text-muted-foreground">No hubs match the current filter.</p>
        <Button
          variant="link"
          size="sm"
          className="mt-1.5 text-xs"
          onClick={() => {
            setActiveFilter("all");
            setSearchQuery("");
          }}
        >
          Clear filters
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1.5">
      {filteredHubs.map((hub) => (
        <HubRow key={hub.id} hub={hub} />
      ))}
    </div>
  );
};
